import * as React from "react";
import { Badge, Row, ButtonGroup, Button } from "react-bootstrap";
import { Helper } from "./helper";
import { IMoveTracker, IMoveTrackerStatus, IBaseResponse } from "@nkr/models/index";
import { MoveTrackerColWrapper } from "./styles";
import { Utility } from "@nkr/services/utility";

interface IProps {
    item: IMoveTracker,
    useBackupPlan: boolean,
    displayTimeZone: string,
    localTimeZone: string,
    isCourier: boolean,
    onViewLogistics: (item: IMoveTracker) => void,
    onShowMap: (url: string) => void,
    onShowGps: (link: string) => void,
    onSwitchPlan: (item: IMoveTracker) => void,
    onSaveNote: (donorId: number, notes: string) => Promise<IBaseResponse>,
    onAcknowledgeAlert: (chainId: number, clusterNumber: number, positionNumber: number) => void
}

class MoveTrackerListCard extends React.Component<IProps, any> {
    handleViewLogistics = () => {
        this.props.onViewLogistics(this.props.item);
    }

    handleShowMap = () => {
        this.props.onShowMap(this.props.item.mapLink);
    }

    handleShowGps = () => {
        this.props.onShowGps(this.props.item.gpsAutomation.gpsLink);
    }

    handleSwitchPlan = () => {
        this.props.onSwitchPlan(this.props.item);
    }

    handleAcknowledgeAlert = () => {
        let { chainId, clusterNumber, positionNumber } = this.props.item;

        this.props.onAcknowledgeAlert(chainId, clusterNumber, positionNumber);
    }

    renderStep = (index: number, label: string, transportMethod: string, item: IMoveTrackerStatus, transportList: string[]) => {
        var { fillColor, textColor, badgeColor } = Helper.getStatusColor(item.status, item.complete);

        var dataLabel = (item.complete ? item.actualDateTime : item.scheduleDateTime);

        if (this.props.displayTimeZone != "DONORCENTER")
            dataLabel = (item.complete ? item.actualDateTimeLocal : item.scheduleDateTimeLocal);

        dataLabel = (transportList.includes(transportMethod) ? "N/A" : dataLabel);

        if (item.status != -1 && dataLabel != "N/A")
            return (
                <React.Fragment key={index}>
                    <MoveTrackerColWrapper xs={5} style={{ display: "flex", alignItems: "center" }}>
                        <div>{label}:</div>
                    </MoveTrackerColWrapper>
                    <MoveTrackerColWrapper xs={7}>
                        <div className="progress" style={{ width: "100%", marginBottom: 1, height: 30, borderRadius: 3 }}>
                            <div className={"progress-bar progress-bar-success"} style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", lineHeight: 0, color: textColor, backgroundColor: fillColor }}>
                                <Badge style={{ backgroundColor: badgeColor, color: textColor }}>{dataLabel}</Badge>
                            </div>
                        </div>
                    </MoveTrackerColWrapper>
                </React.Fragment>
            );
        else
            return (
                <React.Fragment key={index}>
                    <MoveTrackerColWrapper xs={5} style={{ display: "flex", alignItems: "center" }}>
                        <div>{label}:</div>
                    </MoveTrackerColWrapper>
                    <MoveTrackerColWrapper xs={7}>
                        <div className="progress" style={{ width: "100%", marginBottom: 1, height: 30, borderRadius: 3 }}>
                            <div className={"progress-bar progress-bar-success"} style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", lineHeight: 0, color: textColor, backgroundColor: fillColor }}>
                                {dataLabel}
                            </div>
                        </div>
                    </MoveTrackerColWrapper>
                </React.Fragment>
            );
    }

    render() {
        const item = this.props.item;
        const transportMethod = item.logistics.transportMethod.toUpperCase();
        const mapButtonStyle = Utility.getMapButtonStyle(item.logistics);

        const steps: any = [
            this.renderStep(0, "Actual Pickup", transportMethod, item.pickup, []),
            this.renderStep(1, "Flight 1", transportMethod, item.flightDeparture1, ["GROUND"]),
            this.renderStep(2, "Flight 2", transportMethod, item.flightDeparture2, ["GROUND", "COMMOBC", "COMMERCIAL", "CHARTER", "COMMONELEGOBC"]),
            this.renderStep(3, "Recovery", transportMethod, item.airlineRecovery, ["GROUND"]),
            this.renderStep(4, "Actual Delivery", transportMethod, item.delivery, [])
        ];

        const kidneyPickup = (this.props.displayTimeZone == "DONORCENTER" ? item.kidneyPickup + " " + (item.rdnCenterId == 0 ? item.donorCenterTimezone : item.rdnCenterTimezone) : item.kidneyPickupLocal + " " + this.props.localTimeZone);
        const kidneyArrival = (this.props.displayTimeZone == "DONORCENTER" ? item.kidneyArrival + " " + item.donorCenterTimezone : item.kidneyArrivalLocal + " " + this.props.localTimeZone);
        const backgroundColor = this.props.useBackupPlan ? "#660000" : "#133366";

        return (
            <Row style={{ marginBottom: 20, border: "1px solid #aaa", paddingBottom: 10 }}>
                <MoveTrackerColWrapper xs={12} style={{ paddingTop: 5, paddingBottom: 5, color: "#FFFFFF", backgroundColor }}>
                    Swap <span style={{ marginLeft: 10, fontWeight: 700 }}>{item.chainId} / {item.clusterNumber} / {item.positionNumber}</span>
                </MoveTrackerColWrapper>

                <MoveTrackerColWrapper xs={5}>
                    Officer:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    {!item.activeAlert ?
                        <span>{item.dutyOfficer}</span>
                        :
                        <Button bsStyle="danger" bsSize="xs" onClick={this.handleAcknowledgeAlert}>{item.dutyOfficer}</Button>
                    }
                </MoveTrackerColWrapper>

                <MoveTrackerColWrapper xs={5}>
                    D Center:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    {item.donorCenter}
                    {item.rdnCenterId > 0 && (
                        <span style={{ paddingLeft: 5 }}>(<span style={{ fontSize: 12, color: 'tomato', fontWeight: 600 }}>{item.rdnCenterAlias}</span>)</span>
                    )}
                </MoveTrackerColWrapper>

                <MoveTrackerColWrapper xs={5}>
                    Scheduled Pickup:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    {kidneyPickup}
                </MoveTrackerColWrapper>

                <MoveTrackerColWrapper xs={5}>
                    R Center:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    {item.recipientCenter}
                </MoveTrackerColWrapper>

                <MoveTrackerColWrapper xs={5}>
                    Scheduled Delivery:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    {kidneyArrival}
                </MoveTrackerColWrapper>

                {this.props.isCourier == false && (
                    <>
                        <MoveTrackerColWrapper xs={5}>
                            Courier:
                        </MoveTrackerColWrapper>
                        <MoveTrackerColWrapper xs={7}>
                            {item.courier}
                        </MoveTrackerColWrapper>
                    </>
                )}

                <MoveTrackerColWrapper xs={5}>
                    Logistics:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    <ButtonGroup>
                        <Button bsSize="xs" style={{ width: 30, padding: "1px 3px" }} onClick={this.handleViewLogistics}>L</Button>
                        <Button bsSize="xs" bsStyle={mapButtonStyle} style={{ width: 30, padding: "1px 3px" }} onClick={this.handleShowMap}>M</Button>
                        {item.gpsAutomation != null && item.gpsAutomation.gpsLink != "" && (
                            <Button bsSize="xs" style={{ width: 30, padding: "1px 3px" }} onClick={this.handleShowGps}>G{item.gpsAutomation.gpsNumber}</Button>
                        )}
                    </ButtonGroup>
                </MoveTrackerColWrapper>

                <MoveTrackerColWrapper xs={5}>
                    Transport:
                </MoveTrackerColWrapper>
                <MoveTrackerColWrapper xs={7}>
                    <div style={{ cursor: "pointer" }} onClick={this.handleSwitchPlan}>{item.logistics.transportMethod}</div>
                </MoveTrackerColWrapper>

                {steps.map((step, index: number) => {
                    return step;
                })}
            </Row>
        );
    }
}

export default MoveTrackerListCard;